import(/* webpackMode: "eager", webpackExports: ["Tag"] */ "__barrel_optimize__?names=Tag!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Blogs/BlogContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Blogs/BlogSeach.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Blogs/Categories.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Blogs/Tags.tsx");
